(() => {
  const normalize = value => value.toLowerCase().normalize('NFKD').replace(/\bsaint\b/g, 'st').replace(/[^a-z0-9]/g, '');
  const bind = scope => {
    const roots = [...scope.querySelectorAll('[data-county-directory]')];
    if (scope.matches?.('[data-county-directory]')) roots.unshift(scope);
    roots.forEach(root => {
      if (root.dataset.countyBound) return;
      const input = root.querySelector('[data-county-search]');
      if (!input) return;
      root.dataset.countyBound = 'true';
      const items = [...root.querySelectorAll('[data-county-item]')];
      const groups = [...root.querySelectorAll('[data-county-group]')];
      const count = root.querySelector('[data-county-count]');
      const empty = root.querySelector('[data-county-empty]');
      const update = () => {
        const query = normalize(input.value.trim());
        let visible = 0;
        items.forEach(item => { item.hidden = !normalize(item.dataset.countyName).includes(query); if (!item.hidden) visible++; });
        groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-county-item]')].some(item => !item.hidden); });
        if (count) count.textContent = count.dataset.template.replace('__COUNT__', String(visible));
        if (empty) empty.hidden = visible !== 0;
        const jumps = root.querySelector('.directory-jumps');
        if (jumps) jumps.hidden = Boolean(query);
      };
      root.querySelector('[data-county-search-ui]').hidden = false;
      input.addEventListener('input', update);
      root.querySelector('[data-county-clear]')?.addEventListener('click', () => { input.value = ''; update(); input.focus(); });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(document)); else bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
